import { GetterTree } from 'vuex';
import { StoreType } from '@/types/store/store.type';
import { ActivityStoreType } from '@/types/store/activity-store.type';

export const getters: GetterTree<ActivityStoreType, StoreType> = {
  getActivity(state) {
    return state.activity;
  },
};
